import React, {useState} from 'react';
import {
  CloseButton,
  CloseButtonIcon,
  Container,
  ContainerImage,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalInfos,
  ModalList,
  ModalSubtitle,
  ModalTitle,
  PromotionBanner,
  PromotionBody,
  PromotionContainer,
  PromotionCoupon,
  PromotionCouponText,
  PromotionIcon,
  PromotionIconCircle,
  PromotionIconContainer,
  PromotionInfo,
  PromotionInfoContainer,
  PromotionProduct,
  PromotionRadio,
  PromotionRow,
  PromotionText,
  PromotionValuesBlock,
  PromotionValuesContainer,
  VehicleBanner,
} from './styles';
import {useTheme} from 'styled-components/native';
import cupomModal from '../../../assets/images/cupom-modal.webp';
import {Button} from '../../Interface/Forms/Buttons/Button';

import {CouponDTO} from '../../../dtos/CouponDTO';
import {RFValue} from 'react-native-responsive-fontsize';

interface Props {
  showModal: boolean;
  onDismiss: () => void;
  onSelectCoupon: (coupon: CouponDTO) => void;
  discounts: CouponDTO[];
  rank?: 'gold' | 'silver' | undefined;
  codigo?: string;
  name?: string;
  productType?: string;
  showPromo?: boolean;
}

export function CuponsModal({
  showModal,
  discounts,
  onDismiss,
  onSelectCoupon,
}: Props) {
  const [selectedCoupon, setSelectedCoupon] = useState<CouponDTO>();

  const theme = useTheme();
  function formatFuelName(name: string) {
    let formattedFuelName = '';
    switch (name.toLowerCase()) {
      case 'gasolina comum':
        formattedFuelName = 'G. Comum';
        break;
      case 'gasolina aditivada':
        formattedFuelName = 'G. Aditivada';
        break;
      case 'etanol':
        formattedFuelName = 'Etanol';
        break;
      case 'diesel comum':
        formattedFuelName = 'D. Comum';
        break;
      case 'diesel s10':
        formattedFuelName = 'D. S10';
        break;
      case 'gasolina podium':
        formattedFuelName = 'G. Podium';
        break;
      case 'etanol aditivado':
        formattedFuelName = 'Etanol Ad.';
        break;
      default:
        formattedFuelName = name;
    }

    return formattedFuelName;
  }

  const handleOnSelectCoupon = () => {
    if (!selectedCoupon) {
      return;
    }
    onSelectCoupon(selectedCoupon);
  };

  return (
    <>
      <Container
        isVisible={showModal}
        onBackButtonPress={onDismiss}
        onBackdropPress={onDismiss}>

        <ContainerImage>
          <VehicleBanner source={cupomModal} resizeMode="cover" />
        </ContainerImage>

        <ModalContent>
          <ModalBody>
            <CloseButton onPress={onDismiss} activeOpacity={0.7}>
              <CloseButtonIcon name="x" />
            </CloseButton>
            <ModalInfos>
              <ModalTitle>Cupons disponíveis</ModalTitle>
              <ModalSubtitle>Selecione um cupom</ModalSubtitle>
            </ModalInfos>
            <ModalList
              contentContainerStyle={{
                marginBottom: RFValue(20),
              }}
              showsVerticalScrollIndicator={false}>
              {discounts.map(desconto => (
                <PromotionContainer
                  key={desconto.codigo}
                  style={{
                    shadowColor: theme.colors.border,
                    shadowOffset: {width: 0, height: 2},
                    shadowOpacity: 0.2,
                    shadowRadius: 4,
                    elevation: 8,
                  }}>
                  <PromotionBanner
                    selected={selectedCoupon?.id === desconto.id}>
                    <PromotionIconContainer
                      onPress={() => setSelectedCoupon(desconto)}>
                      <PromotionIconCircle>
                        <PromotionIcon
                          name="ticket"
                          color={theme.colors.primary}
                        />
                      </PromotionIconCircle>
                    </PromotionIconContainer>
                    <PromotionBody>
                      <PromotionRow onPress={() => setSelectedCoupon(desconto)}>
                        <PromotionInfoContainer>
                          <PromotionInfo>
                            <PromotionText>Combustível</PromotionText>
                            <PromotionCouponText>
                              {desconto.codigo}
                            </PromotionCouponText>
                          </PromotionInfo>
                          <PromotionRadio
                            selected={selectedCoupon?.id === desconto.id}
                          />
                        </PromotionInfoContainer>
                      </PromotionRow>

                      <PromotionValuesContainer
                        horizontal
                        showsHorizontalScrollIndicator={false}>
                        {desconto.produtos.map(produto => (
                          <PromotionValuesBlock
                            key={produto.descricao}
                            onPress={() => setSelectedCoupon(desconto)}>
                            <PromotionCoupon>
                              {produto.valorComDesconto}
                            </PromotionCoupon>

                            <PromotionProduct>
                              {formatFuelName(produto.descricao)}
                            </PromotionProduct>
                          </PromotionValuesBlock>
                        ))}
                      </PromotionValuesContainer>
                    </PromotionBody>
                  </PromotionBanner>
                </PromotionContainer>
              ))}
            </ModalList>
          </ModalBody>
          <ModalFooter>

              <Button
                enabled={!!selectedCoupon}
                title="Selecionar"
                onPress={handleOnSelectCoupon}
              />

          </ModalFooter>
        </ModalContent>
      </Container>
    </>
  );
}
